import { PayloadAction } from '@reduxjs/toolkit';
import { mountingPlateActions } from '.';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import {
  selectCustomerNumber,
  selectErpSystem,
  selectLanguageId,
} from 'app/features/erpSystem/slice/selectors';
import { erpalPayloadDTO } from 'app/features/price/slice/utils';
import { transformMountingPlate } from './utils';
import { mountingPlateActions as actions } from '.';
import { selectStoreId } from 'app/features/salesOrganisation/slice/selectors';
function* setMountingPlate(action: PayloadAction<any>) {
  const mountingPlate = action.payload;
  const { setMountingPlateSuccess, setMountingPlateFailure } =
    mountingPlateActions;

  try {
    const customerNumber = yield select(selectCustomerNumber);
    const languageId = yield select(selectLanguageId);
    const erpSystem = yield select(selectErpSystem);
    const storeId = yield select(selectStoreId);

    const requestPayload = yield erpalPayloadDTO([action.payload]);
    const shopId = storeId % 10; // Get last digit of store id Ex: 100001  => 1

    const priceResponse = yield call(
      fetch,
      `/valve-configurator/api/price?customerNumber=${customerNumber}&shopId=${shopId}&currency=EUR&languageId=${languageId}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestPayload),
      },
    );
    const mountingPlatePrice = yield priceResponse.json();

    const stockResponse = yield call(
      fetch,
      `/valve-configurator/api/stockStatus?erpSystem=${erpSystem}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestPayload),
      },
    );
    const mountingPlateStock = yield stockResponse.json();

    return yield put(
      setMountingPlateSuccess(
        transformMountingPlate(
          mountingPlate,
          mountingPlatePrice.items,
          mountingPlateStock.items,
        ),
      ),
    );
  } catch (e) {
    yield put(setMountingPlateFailure(e));
  }
}

export function* mountingPlateSaga() {
  yield takeLatest(actions.setMountingPlate.type, setMountingPlate);
}
